import React, { Component } from 'react'
import axios from 'axios';
import { Notifications } from '../common/notification';
import Select from 'react-select';
import { BILLING_CREATED } from '../../config/rest_endpoints';


export class AccountBilling extends Component {
    constructor(props) {
        super(props);
        this.state = {
            charges: '',
            rate: '',
            selectedCharges: null,
            selectedtype: null,
            optionsConnectCharges: [
                { value: '6s', label: '6s' },
                { value: '12s', label: '12s' },
                { value: '18s', label: '18s' },
                { value: '24s', label: '24s' },
                { value: '30s', label: '30s' },
                { value: '60s', label: '60s' },
            ],
            optionsAccountType: [
                { value: 'Postpay', label: 'Postpay' },
                { value: 'Prepay', label: 'Prepay' }
            ],
            roundMethod: [
                { value: '*up', label: 'Up' },
                { value: '*down', label: 'Down' }
            ],
            selectRoundMethod: '',
            roundDigits: [
                { value: 4, label: '4' },
                { value: 5, label: '5' },
                { value: 6, label: '6' }
            ],
            selectRoundDigits: '',
            subsequent: [
                { value: '6s', label: '6s' },
                { value: '12s', label: '12s' },
                { value: '18s', label: '18s' },
                { value: '30s', label: '30s' },
                { value: '60s', label: '60s' },
            ],
            subsequentSelect: '',
            billList: [],
            msg: '',
        }
        this.handleSelectAccount = this.handleSelectAccount.bind(this)
        this.handleSelectCharges = this.handleSelectCharges.bind(this)
        this.onHandleChange = this.onHandleChange.bind(this)
        this.onSubmitBill = this.onSubmitBill.bind(this)
        this.handleRoundDigitsSelect = this.handleRoundDigitsSelect.bind(this)
        this.handleRoundMethodSelect = this.handleRoundMethodSelect.bind(this)
        this.handleSubsequentSelect = this.handleSubsequentSelect.bind(this)
    }

    onHandleChange(e) {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleSelectCharges(selectedCharges) {
        this.setState({ selectedCharges });
        console.log(`Option selectedCharges:`, selectedCharges);
    };

    handleSelectAccount(selectedtype) {
        this.setState({ selectedtype });
        console.log(`Option selectedtype:`, selectedtype);
    };

    handleSubsequentSelect(subsequentSelect) {
        this.setState({ subsequentSelect })
    }

    handleRoundMethodSelect(selectRoundMethod) {
        this.setState({ selectRoundMethod })
    }

    handleRoundDigitsSelect(selectRoundDigits) {
        this.setState({ selectRoundDigits })
    }

    onSubmitBill() {
        const { User, userId, charges, rates, selectedCharges, subsequentSelect, selectRoundMethod, selectRoundDigits } = this.state
        var billingAdd = {
            "initialInc": selectedCharges.value,
            "connectFee": parseFloat(charges),
            "ratePerMin": parseFloat(rates),
            "subsequentInc": subsequentSelect.value,
            "roundingMethod": selectRoundMethod.value,
            "roundingDigits": parseInt(selectRoundDigits.value)
        }
        console.log('billingAdd', billingAdd)
        var headers = { 'Authorization': "Bearer " + User.token }
        axios.post(`${BILLING_CREATED}/${userId}/billing/create`, billingAdd, { headers }).then(res => {
            console.log('res :', res);
            if (res) {
                this.setState({
                    msg: res.data.message
                })
                Notifications.notify(this.state.msg, "Created", "success")
                this.billingListing()
            }
        })
    }

    render() {
        const { subsequentSelect, subsequent, selectRoundDigits, roundDigits, selectRoundMethod, roundMethod, charges, rates, selectedOption, optionsConnectCharges, optionsAccountType, selectedCharges, selectedtype, billList, isGetting, isError } = this.state

        const labelStyle = {
            fontWeight: '500',
            fontSize: '13px',
            color: '#475569',
            marginBottom: '6px'
        };

        return (
            <div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label style={labelStyle}>Connect Charges</label>
                            <input type="number" className="form-control" name="charges" value={charges} onChange={this.onHandleChange} placeholder="Enter charges" />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label style={labelStyle}>Rate Per Min</label>
                            <input type="number" className="form-control" name="rates" value={rates} onChange={this.onHandleChange} placeholder="Enter rate" />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label style={labelStyle}>Initial Increment</label>
                            <Select
                                value={selectedCharges}
                                onChange={this.handleSelectCharges}
                                options={optionsConnectCharges}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label style={labelStyle}>Account Type</label>
                            <Select
                                value={selectedtype}
                                onChange={this.handleSelectAccount}
                                options={optionsAccountType}
                                isDisabled
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Subsequent Increment</label>
                            <Select
                                value={subsequentSelect}
                                onChange={this.handleSubsequentSelect}
                                options={subsequent}
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Rounding Method</label>
                            <Select
                                value={selectRoundMethod}
                                onChange={this.handleRoundMethodSelect}
                                options={roundMethod}
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Rounding Digits</label>
                            <Select
                                value={selectRoundDigits}
                                onChange={this.handleRoundDigitsSelect}
                                options={roundDigits}
                            />
                        </div>
                    </div>
                </div>
                <div style={{borderTop:'1px solid #E2E8F0',marginTop:'16px',paddingTop:'20px',display:'flex',justifyContent:'flex-end'}}>
                    <button
                        type="submit"
                        onClick={this.onSubmitBill}
                        style={{
                            background: this.state.isLoad ? '#94A3B8' : 'linear-gradient(135deg, #10B981, #059669)',
                            color: '#FFFFFF',
                            border: 'none',
                            borderRadius: '10px',
                            padding: '10px 24px',
                            fontSize: '13px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
                            transition: 'all 200ms ease'
                        }}
                    >
                        <i className={this.state.isLoad ? "icon-spinner4 spinner" : "icon-coins"} style={{fontSize:'14px'}}></i>
                        Add Bill
                    </button>
                </div>
            </div>
        )
    }
}

export default AccountBilling
